import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationClienteGrupo } from '../integration-cliente-grupo';

@Injectable({
    providedIn: 'root'
})
export class IntegrationClienteGrupoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/clientegrupo`;
    }

    /** Executa a integração de leitura dos grupos de clientes com os sistemas ERP's */
    execReadIntegration(entity: IntegrationClienteGrupo): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(this.pathApi, null, {params, responseType: 'text'});
    }
}
